import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { PageLayout } from "../components/page-layout";

export const ProfilePage = () => {
  const { user, getAccessTokenSilently  } = useAuth0();

  
  const verificarPermissao = async () => {
      const token = await getAccessTokenSilently();
      const payload = JSON.parse(atob(token.split(".")[1])); // decodifica JWT

      // Verifica se tem a permissão desejada
      const temPermissao = payload.permissions?.includes("read:asx");
      console.log("Tem permissão?", payload.permissions);
    };

    //verificarPermissao();


  if (!user) {
    return null;
  }

  return (
    <PageLayout>
      <div className="content-layout">
        <h1 id="page-title" className="content__title">
          Profile Page
        </h1>
        <div className="content__body">
          
          <div className="profile-grid">
            <div className="profile__header">
              <img
                src={user.picture}
                alt="Profile"
                className="profile__avatar"
              />
              <div className="profile__headline">
                <h2 className="profile__title">{user.name}</h2>
                <span className="profile__description">{user.email}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};
